/**
 * Stałe współdzielone przez flow rejestracji i AuthProvider.
 *
 * Rozdzielone do osobnego modułu, bo klucze czyta zarówno AuthPage (zapis przed
 * signUp / z ?ref=) jak i useAuth (konsumpcja po SIGNED_IN) — import strony
 * w providerze robiłby cykl.
 */

/** Deterministyczny sygnał „to była rejestracja" → po SIGNED_IN kierujemy na /start
 *  (onboarding), nie na hub. Pewniejsze niż heurystyka created_at < 60s, którą skew
 *  zegara na mobile potrafił wywrócić. sessionStorage — flaga żyje tylko w tej karcie. */
export const ONBOARDING_REDIRECT_KEY = "af_onboarding_redirect";

/** Kod polecający z ?ref=. localStorage, bo musi przetrwać potwierdzenie maila
 *  otwarte w nowej karcie/sesji. Konsumowany raz, po zapisie polecenia. */
export const REFERRAL_CODE_KEY = "af_referral_code";
